.container {
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
}
